export default __webpack_public_path__ + "static/platform-editeur-rapport-59b4c568d44854440185546655355e1d.png";